import React, { ReactElement } from 'react'

import { Box, ModalMobileCTA } from '@mindfulchefuk/design-system'
import {
  DeliveryRecipe,
  RecipeWithQuantity,
} from '@mindfulchefuk/features/Recipes/interfaces'
import { RecipeActionButtons } from '@mindfulchefuk/features/Recipes/components/RecipeCardWithClaims/RecipeActionButtons/RecipeActionButtons'

export type TRecipeModalQuantitySelector = {
  isAdditionDisabled: boolean
  onDecrement: (recipe: RecipeWithQuantity) => void
  onIncrement: (
    recipe: RecipeWithQuantity,
    isRecipeRecommended: boolean
  ) => void
  recipe: RecipeWithQuantity | DeliveryRecipe
}

export const RecipeModalQuantitySelector = ({
  isAdditionDisabled,
  onIncrement,
  onDecrement,
  recipe,
}: TRecipeModalQuantitySelector): ReactElement => {
  return (
    <ModalMobileCTA justifyItems={['center', 'flex-start']}>
      <Box width={['275px', '240px']}>
        <RecipeActionButtons
          isBasketFull={isAdditionDisabled}
          onAddRecipe={() => onIncrement(recipe, recipe.recommended)}
          onSubtractRecipe={() => onDecrement(recipe)}
          quantityInBasket={recipe?.quantity}
          recipeTitle={recipe.title}
          isModal
          portionCount={recipe.portions}
        />
      </Box>
    </ModalMobileCTA>
  )
}
